import { faStar as star } from '@fortawesome/free-solid-svg-icons';

import { TrlFormattedMessagePlain } from '»utils/i18n';

import { StarIconStyled } from './TrlEmail.styles';

export const columns = ({
  favoriteEmail,
  handleFavoriteChange,
  isExtraLarge,
  isLarge,
  isMedium,
}) => {
  const getEmailWidth = () => {
    if (isMedium) return '220px';

    return 'auto';
  };

  const getEmailDescrWidth = () => {
    if (isExtraLarge) return '180px';

    if (isLarge) return '160px';

    if (isMedium) return 'auto';

    return 0;
  };

  const getEmptyColWidth = () => {
    if (isLarge) return 'auto';

    return 0;
  };

  return [
    {
      field: 'contact',
      title: TrlFormattedMessagePlain({ id: 'TRLT_UI-EMAIL' }),
      width: getEmailWidth(),
    },
    {
      field: 'descr',
      title: TrlFormattedMessagePlain({ id: 'TRLT_UI-DESCRIPTION' }),
      width: getEmailDescrWidth(),
    },
    {
      field: 'r',
      cellTemplate: 'TrlButtonCell',
      type: 'radio',
      title: 'favorite',
      headerComponent: <StarIconStyled icon={star} />,
      fieldValue: 'contactId',
      selectedValue: favoriteEmail,
      handleChange: handleFavoriteChange,
      headerClassName: 'customClassCenter',
      className: 'customClassCenter',
      width: '55px',
    },
    {
      field: 'space',
      width: getEmptyColWidth(),
    },
  ];
};
